// https://codesandbox.io/p/sandbox/rzdhd?file=%2Fexamples%2FBasicComponent%2Findex.js%3A30%2C24-30%2C31

import React, { useRef, useImperativeHandle, forwardRef, useState } from "react";
import { useReactToPrint } from "react-to-print";  // Move this to the top
import { POST_CHEQUE_PRINT } from '../../helpers/url_helper';
import { post } from '../../helpers/api_helper';
import { toast } from 'react-toastify';
import Loader from "../../components/Loader";

const { createCanvas } = require('canvas');


const ChequePreview = forwardRef((props, ref) => {
    const [isLoader, setLoader] = useState(0);

    const componentRef = useRef(null);
    const [checkInfo, SetCheckInfo] = useState(null);

    function splitTextToFit(text, maxWidthMM, font = 'Arial', fontSize = 16) {
        // Convert maxWidth from mm to pixels
        const maxWidthPx = (maxWidthMM / 25.4) * 96;  // 1 inch = 25.4mm, 1 inch = 96px

        // Create a canvas to measure text width
        const canvas = createCanvas(100, 100); // Dummy canvas, only for measurement
        const ctx = canvas.getContext('2d');
        ctx.font = `${fontSize}px ${font}`;

        const words = text.split(' ');
        let currentLine = '';
        const result = [];

        for (let word of words) {
            const testLine = currentLine ? `${currentLine} ${word}` : word;
            const width = ctx.measureText(testLine).width;

            if (width <= maxWidthPx) {
                currentLine = testLine;
            } else {
                result.push(currentLine);
                currentLine = word;
            }
        }

        if (currentLine) {
            result.push(currentLine);
        }

        return result;
    }
    function formatAmount(amount) {
        // Ensure the amount is a valid number
        if (isNaN(amount)) {
            throw new Error('Amount must be a valid number');
        }

        // Convert the number to a string
        const numStr = Math.floor(amount).toString();

        // Split the string into the last 3 digits and the remaining part
        const lastThree = numStr.slice(-3); // Last 3 digits
        const otherPart = numStr.slice(0, -3); // Remaining part

        // Add commas every 2 digits in the remaining part
        const formattedOtherPart = otherPart.replace(/\B(?=(\d{2})+(?!\d))/g, ',');

        // Combine the formatted parts with the last 3 digits
        const formattedAmount = otherPart
            ? `${formattedOtherPart},${lastThree}`
            : lastThree;

        // Append '/-' to indicate the end of the formatted amount
        return `${formattedAmount}/-`;
    }

    function amountToWords(amount) {
        const ones = [
            '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
            'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
            'Eighteen', 'Nineteen'
        ];

        const tens = [
            '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
        ];

        const places = ['', 'Thousand', 'Lakh', 'Crore'];

        function convertToWords(num) {
            if (num === 0) return 'Zero';

            let words = '';
            let placeIndex = 0;

            // Handle first 3 digits separately (rightmost group)
            let chunk = num % 1000;
            if (chunk > 0) {
                words = `${convertHundreds(chunk)} ${places[placeIndex]} ${words}`;
            }
            num = Math.floor(num / 1000);
            placeIndex++;

            // Handle remaining groups (2 digits per group in Indian format)
            while (num > 0) {
                chunk = num % 100;
                if (chunk > 0) {
                    words = `${convertHundreds(chunk)} ${places[placeIndex]} ${words}`;
                }
                num = Math.floor(num / 100);
                placeIndex++;
            }

            return words.trim();
        }

        function convertHundreds(num) {
            if (num === 0) return '';
            else if (num < 20) return ones[num];
            else if (num < 100) return `${tens[Math.floor(num / 10)]} ${ones[num % 10]}`;
            else return `${ones[Math.floor(num / 100)]} Hundred ${convertHundreds(num % 100)}`;
        }

        // Handle decimal part (if any)
        const [integerPart, decimalPart] = amount.toFixed(2).split('.');
        let result = convertToWords(Number(integerPart));

        if (decimalPart !== '00') {
            result += ` and ${convertToWords(Number(decimalPart))} Paise`;
        }

        return result + ' Only';
    }

    const printFn2 = useReactToPrint({
        contentRef: componentRef,
        documentTitle: "AwesomeFileName",
    });


    const print = async (chequeId) => {
        setLoader(1);
        var res_data = await post(POST_CHEQUE_PRINT, { chequeId: chequeId });
        if (res_data.status) {
            SetCheckInfo(res_data.data.cheque_info);
        } else {
            toast.error(res_data.message);
        }
       
        setTimeout(async() => {
            await printFn2()
            setLoader(0);
            setTimeout(() => {
                props.callback();
            }, 1000)
        }, 1000)

    }
    useImperativeHandle(ref, () => ({
        print
    }));

    return (<>
        {isLoader > 0 && <Loader />}

        <div style={{ "display": "none" }}>
            <div ref={componentRef}>
                <style>
                    {`
                    @media print {
                        @page {
                            size: A4;
                            margin: 0;
                        }
                    }
                    .body {
                        margin: 0;
                        padding: 0;
                        width: 210mm; /* A4 width in landscape */
                        height: 297mm; /* A4 height in landscape */
                        display: flex;
                        justify-content: center; /* Center content horizontally */
                        align-items: top; /* Center content vertically */
                        // border: 1px solid #000;
                        position: absolute;
                    }
                    .ltr_center_portrait{
                        top: 208px;
                        transform: rotate(90deg);
                    }
                `}
                </style>
                {checkInfo &&
                    <div className="body"> 
                        <div className="ltr_center_portrait" style={{ "width": `${checkInfo.chequeWidth}mm`, height: `${checkInfo.chequeHeight}mm`, position: "relative", backgroundSize: "100%", fontSize: '15px', "overflow": "hidden" , "border" : '0px solid #000'}}>
                            {/* Data */}
                            <div style={{ position: "absolute", top: `${checkInfo.chequeDateStartingLocationFromTop}mm`, left: `${checkInfo.chequeDateStartingLocationFromLeft}mm`, letterSpacing: `${checkInfo.chequeDateDistanceBetweenCharacters}mm`, fontWeight: 700 }}>{checkInfo.date}</div>

                            {/* A/C Payee */}
                            {checkInfo.chequeType === 'A/C Payee' && <>
                                <div style={{ position: "absolute", top: `5.5mm`, left: `-8mm`, fontWeight: 700, border: '1px solid #000', borderLeft: '0px', borderRight: '0px', padding: '0px 20px', transform: 'rotate(-36deg)', "width": "40mm", textAlign: "center" }}>A/C Payee </div>
                            </>}
                            {checkInfo.chequeType === 'Crossed Cheque' && <>
                                <div style={{ position: "absolute", top: `5.5mm`, left: `-8mm`, fontWeight: 700, border: '1px solid #000', borderLeft: '0px', borderRight: '0px', padding: '0px 20px', transform: 'rotate(-36deg)', "width": "40mm", textAlign: "center" }}>&nbsp; </div>
                            </>}
                            {checkInfo.chequeType === 'Cancelled' && <>
                                <div style={{ position: "absolute", top: `40mm`, left: `60mm`, fontWeight: 700, border: '1px solid #000', borderLeft: '0px', borderRight: '0px', padding: '5px 60px', transform: 'rotate(-36deg)', textAlign: "center", fontSize: "25px" }}>Cancelled</div>
                            </>}

                            {/* name */}
                            <div style={{ position: "absolute", top: `${checkInfo.payeeNameStartingLocationFromTop}mm`, left: `${checkInfo.payeeNameStartingLocationFromLeft}mm`, fontWeight: 700, width: `${checkInfo.payeeNameWidth}mm`, overflow: `hidden` }}>{checkInfo.name}</div>
                            {/* amount Figures */}
                            <div style={{ position: "absolute", top: `${checkInfo.amountFiguresStartingLocationFromTop}mm`, left: `${checkInfo.amountFiguresStartingLocationFromLeft}mm`, fontWeight: 700, width: `${checkInfo.amountFiguresWidth}mm`, overflow: `hidden` }}>{formatAmount(checkInfo.amount)}</div>

                            <div style={{ position: "absolute", top: `${checkInfo.amountWordsStartingLocation1LineFromTop}mm`, left: `${checkInfo.amountWordsStartingLocation1LineFromLeft}mm`, fontWeight: 700, width: `${checkInfo.amountWordsWidth}mm`, overflow: `hidden` }}>{splitTextToFit(amountToWords(checkInfo.amount), checkInfo.amountWordsWidth)[0]}</div>
                            <div style={{ position: "absolute", top: `${checkInfo.amountWordsStartingLocation2LineFromTop}mm`, left: `${checkInfo.amountWordsStartingLocation2LineFromLeft}mm`, fontWeight: 700, width: `${checkInfo.amountWordsWidth}mm`, overflow: `hidden` }}>{splitTextToFit(amountToWords(checkInfo.amount), checkInfo.amountWordsWidth)[1]}</div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </>);
});

export default ChequePreview;
